export const imageKeys = {
  mobile: ["960x320"],
  tablet: ["1920x320"],
  desktop: ["2560x320"],
  buylistHeader: ["900x254", "1800x508", "1350x381", "1184x333"],
};

export const bannerPresets = {
  adNumber: "",
  advertiser: "",
  advertiserId: "",
  alt: "",
  bannerTitle: "",
  bannerType: "simplebrand",
  bannerURL: "",
  bespokeTemplate: true,
  buylistHeader: {
    name: "",
    path: "",
    size: "1184x333",
  },
  currentUser: false,
  desktop: {
    name: "Cadbury ice cream",
    path: "https://firebasestorage.googleapis.com/v0/b/dh-media-banners-42191.appspot.com/o/images%2Fbrand-template%2F1746179055541-white-vt-cadbury-desktop.jpg?alt=media&token=e2f497bb-e235-4f9a-abbe-8b2491e83892",
    size: "2560x320",
  },
  key: "",
  lastModAt: "",
  lastModBy: "",
  mobile: {
    name: "",
    path: "",
    size: "960x320",
  },
  retailer: "tesco",
  status: 2,
  tablet: {
    name: "",
    path: "",
    size: "1920x320",
  },
  templateId: "12415318",
  userId: "",
};
